/**多语言翻译方法 提供统一的方法，方便后续升级支持*/
export const t = text => {
    return text;
};